import React from 'react';
import { Grid } from 'react-bootstrap';

class Footer extends React.PureComponent {
	render() {
		return (
            <footer className="footer">
                <Grid fluid>
                    <nav className="pull-left">
                        <ul>
                            <li>
                                <a href="#help">
                                    עזרה
                                </a>
                            </li>
                            <li>
                                <a href="#forms">
                                    טפסים
                                </a>
                            </li>
                        
                            <li>
                                <a href="#blog">
                                   בלוג
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <p className="copyright pull-right">
                        &copy; {(new Date()).getFullYear()} <a href="https://digma.org.il">דיגמה יעוץ הערכה ומיון</a>, פותח באהבה לטובת החברה
                    </p>
                </Grid>
            </footer>
		);
	}
}

export default Footer;
